export enum MenuItemNameEnum {
  PARTICULAR = 'particular',
  ANTECIPACOES = 'antecipacoes',
  GESTAO_FINANCEIRA = 'gestao-financeira',
  CONVENIOS = 'convenios',
  SIMULADOR_DE_VENDAS = 'simulador-de-vendas',
  PLANO_DE_SAUDE = 'plano-de-saude',
}
